module.exports = __webpack_public_path__ + "img/calendar_thin.0d502097.svg";